import PasswordResetScreen from './PasswordResetScreen';

export default PasswordResetScreen;
